import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rapid-course',
    templateUrl: './rapid-course.component.html',
    styleUrls: ['./rapid-course.component.css'],
    standalone: false
})
export class RapidCourseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  openExternalLink(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/4f2bae130fae3e59b0ca8c8491e73884';
  }

  bookSlot():void{
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/4f2bae130fae3e59b0ca8c8491e73884/book-a-slot';
  }
}
